import { render } from "./MyPlatforms.vue?vue&type=template&id=758b5f1a&scoped=true"
import script from "./MyPlatforms.vue?vue&type=script&lang=js"
export * from "./MyPlatforms.vue?vue&type=script&lang=js"

import "./MyPlatforms.vue?vue&type=style&index=0&id=758b5f1a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-758b5f1a"]])

export default __exports__